// 本人 or 委託人簽退
export default {
  methods: {
    UnregisterUnitOwner (requestData) {
      console.log(requestData)
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Register.UnregisterUnitOwner(
          requestData
        ).then(res => {
          if (res.status === 200) {
            resolve({ status: res.status })
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve({
              status: err.response.status,
              message: err.response.data.title
            })
          }
        })
      })
    }
  }
}
